<template>
	<form class="form">
		<FormSearchableDropdown ref="searchableInput" :label="$t('form.label.employee.name')"
			v-model="form.fields.employee_id" name="employee_name" :options="employeeOptions" required />
		<FormInput ref="startDate" :label="$t('form.label.employee.start_date')" v-model="form.fields.employee_start" name="start_date_employee" type="date"
			required />
		<FormSelect :label="$t('form.label.birthday_day')" name="birthday" :options="dayOptions"
			v-model="form.fields.employee_birth_day" size="medium" />
		<FormSelect :label="$t('form.label.birthday_month')" name="birth_month" :options="monthOptions"
			v-model="form.fields.employee_birth_month" size="medium" />
	</form>
</template>

<script>
import { FormInput, FormSearchableDropdown, FormSelect } from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
	name: 'AddEditEmployee',
	mixins: [FormValidMixin],
	components: { FormInput, FormSearchableDropdown, FormSelect },
	data() {
		return {
			form: {
				fields: {
					employee_id: {
						value: '',
						valid: false
					},
					employee_start: {
						value: '',
						valid: false
					},
					employee_birth_day: {
						value: '',
						valid: false
					},
					employee_birth_month: {
						value: '',
						valid: false
					}
				},
				valid: false
			}
		}
	},
	computed: {
		dayOptions() {
			const days = [{ key: 'empty', value: this.$t('leaveEmpty') }]
			for (let i = 1; i <= 31; i++) {
				days.push({ key: i, value: i })
			}
			return days
		},
		employeeOptions() {
			return this.$employee.all
				? Array.from(this.$employee.all)
					.map(employee => ({ key: employee.id, value: employee.full_name }))
					.sort((a, b) => a.value.localeCompare(b.value))
				: []
		},
		monthOptions() {
			const months = [{ key: 'empty', value: this.$t('leaveEmpty') }]
			let date = new Date
			for (let i = 0; i < 12; i++) {
				date.setMonth(i)
				let writtenMonth = date.toLocaleDateString(this.$i18n.locale, { month: 'long' })
				months.push({
					key: i + 1,
					value: writtenMonth.charAt(0).toUpperCase() + writtenMonth.substring(1)
				})
			}
			return months
		}
	},
	methods: {
		async submit() {
			if (this.form.valid) {
				const formData = {
					employment_start_date: this.form.fields.employee_start.value,
					birthday_day: this.form.fields.employee_birth_day.value !== 'empty'
						? this.form.fields.employee_birth_day.value
						: null,
					birthday_month: this.form.fields.employee_birth_month.value !== 'empty'
						? this.form.fields.employee_birth_month.value
						: null
				}

				await this.$employee.update(parseInt(this.form.fields.employee_id.value), formData)

				this.$router.back()
				this.messageToTooltip()
			}
		},
		messageToTooltip() {
			let employeeName
			if (this.$employee.all) {
				employeeName = Array.from(this.$employee.all).find(({ id }) => id.toString() === this.form.fields.employee_id.value.toString()).full_name
			}

			if (this.$route.query.action === this.$query.ACTION.EDIT) {
				this.$popup.report(`${this.$t('popup.theEmployee')} ${employeeName} ${this.$t('popup.modifiedElement')}`, false)
			} else {
				this.$popup.report(`${this.$t('popup.theEmployee')} ${employeeName} ${this.$t('popup.deletedElement')}`, false)
			}
		},
	},
	watch: {
		'form.fields.employee_id': {
			handler() {
				if (this.form.fields.employee_id && this.$employee.all) {
					const employee = Array.from(this.$employee.all).find(({ id }) => id.toString() === this.form.fields.employee_id.value.toString())

					if (employee) {
						this.form.fields.employee_start.value = employee.employment_start_date
						this.form.fields.employee_birth_day.value = employee.birthday_day
						this.form.fields.employee_birth_month.value = employee.birthday_month

						this.$refs.startDate.$el.querySelector('input').focus()
					}
				}
			},
			deep: true
		}
	}
}
</script>